module.exports = __webpack_public_path__ + "img/category-detail-icon3.b1ebb511.svg";